<template>
  <div class="home page congrats">
     <img id="hp" src="@/assets/images/zloy.png"/><br/>
  </div>
</template>

<script>


export default {
  name: 'Hp',

  components: {
   
  },

  data () {
    return {
    }
  },

  methods: {
    
  }
}
</script>

<style lang="scss" scoped>
.some-modal-content {
  min-width: 400px;
  padding: 25px;

  .buttons button {
    padding: 10px;
    margin: 10px;
  }
}
.congrats {
    text-align: center;
}
.hp {
    margin: 0 auto;
}
</style>
